"use client";

import { usePathname } from "next/navigation";
import React from "react";

export default function FloatingCTAVisibility({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  const hideCTA =
    pathname.startsWith("/campaign/") ||
    pathname.startsWith("/partnership/");

  if (hideCTA) return null;

  return <>{children}</>;
}